import { render, staticRenderFns } from "./cmsSettings.vue?vue&type=template&id=255ec95f&"
import script from "./cmsSettings.vue?vue&type=script&lang=js&"
export * from "./cmsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports